<template>
  <div class="refuse">
    <span>
      <span>*</span>
      请输入财务拒回原因:
    </span>
    <Input
      class="ref_input"
      v-model="inputValue"
      type="textarea"
      :autosize="{minRows: 2,maxRows: 5}"
      placeholder="Enter something..."
    />
    <div class="pop-btn">
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error" class="sav-btn" @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from '@/assets/js/ChineseDictionary';
export default {
  name: 'Refuse',
  inject: ['moduleComponentName', 'instanceRouteQuery', 'instanceRoute'],
  data() {
    return {
      inputValue: '',
      tableName: '', // 主表表名
      tableId: '', // 主表ID
      itemId: '', // 子表ID
    }
  },
  created() {
    this.chineseName = ChineseDictionary;
    const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.tableId = tableId;
    this.itemId = itemId;
  },
  methods: {
    save() {
      if (!this.inputValue.trim()) {
        const data = {
          mask: true,
          title: '警告',
          content: '请输入拒回原因'
        };
        this.$Modal.fcWarning(data);
        return;
      }
      const params = {
        inputValue: this.inputValue,
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
        user: this.$store.state.global.userInfo,
        tag: '1',
      };
      this.$network.post('/p/cs/financeRefund', params)
        .then((res) => {
          if (res.data.data.code == 0) {
            this.$Modal.fcSuccess({
              title: '成功',
              content: res.data.data.message
            });
            this.$emit('closeActionDialog', true); // 关闭弹框
            this.$store.commit('global/tabCloseAppoint', {
              tableName: this.instanceRouteQuery.tableName, //(主表表名),
              routeFullPath: this.instanceRoute//（路由path）
            });
          } else {
            this.$Modal.fcError({
              title: '失败',
              content: res.data.data.message
            });
            this.$emit('closeActionDialog', true); // 关闭弹框
          }

        });

    }, // 确定
    cancel() {
      this.$emit('closeActionDialog', false); // 关闭弹框
    }, // 取消

  },
}
</script>

<style lang='less'>
.refuse {
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>
